import { Injectable } from '@angular/core';
import { NgElement, WithProperties } from '@angular/elements';
import { select, Store } from '@ngrx/store';
import { selectContextCore } from '@store/context/context.selector';
import { IHotelsAppState } from '@store/index';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';

interface IPropHeader {
  product: string;
  country: string;
  locale: string;
  site: string;
  redirect: string;
}
@Injectable({
  providedIn: 'root',
})
export class HFService {
  private headerWC = document.createElement('am-header-wc') as NgElement &
    WithProperties<IPropHeader>;
  private footerWC = document.createElement('am-footer-wc') as NgElement &
    WithProperties<{ country: string }>;
  private context$: Observable<any>;

  constructor(private store$: Store<IHotelsAppState>) {
    this.context$ = this.store$.pipe(select(selectContextCore));
  }

  public showHeaderFooter(): void {
    const doomAppRoot = document.querySelector('am-root') as HTMLElement;
    this.headerWC.setAttribute('product', 'hotels');
    this.context$.pipe(take(1)).subscribe((context) => {
      this.headerWC.setAttribute('country', context.site);
      this.headerWC.setAttribute('locale', context.locale);
      this.headerWC.setAttribute('site', context.site);

      this.footerWC.setAttribute('country', context.site);

      document.body.insertBefore(this.headerWC, doomAppRoot);
      document.body.appendChild(this.footerWC);
    });
  }
}
